module.exports = __webpack_public_path__ + "static/media/ceuterraemar-partitura.6ba536af.png";